/**
 * OnePass tabs — section#onepass (parts/sections/one_pass.php).
 *
 * The "OnePass tabs" IIFE from the original section-scripts-b.js, unchanged.
 * It adds .op-ready to the section, keeps .is-active / aria-selected /
 * tabindex / aria-hidden in sync and handles arrow/Home/End keys on the
 * vertical tablist. No endpoints, no globals.
 */
/* ---------- OnePass tabs ---------- */
(function(){
  var root = document.getElementById('onepass');
  if(!root) return;
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.op-tab[role="tab"]'));
  if(!tabs.length) return;
  var panels = tabs.map(function(t){ return document.getElementById(t.getAttribute('aria-controls')); });
  var current = 0;
  function select(i, moveFocus){
    if(i < 0) i = tabs.length - 1;
    if(i >= tabs.length) i = 0;
    tabs.forEach(function(t, n){
      var on = n === i;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      if(panels[n]){
        panels[n].classList.toggle('is-active', on);
        if(on){ panels[n].removeAttribute('aria-hidden'); }
        else{ panels[n].setAttribute('aria-hidden', 'true'); }
      }
    });
    current = i;
    if(moveFocus) tabs[i].focus();
  }
  tabs.forEach(function(t, n){
    t.addEventListener('click', function(){ if(n !== current) select(n, false); });
    t.addEventListener('keydown', function(e){
      var k = e.key, next = null;
      if(k === 'ArrowDown' || k === 'ArrowRight') next = current + 1;
      else if(k === 'ArrowUp' || k === 'ArrowLeft') next = current - 1;
      else if(k === 'Home') next = 0;
      else if(k === 'End') next = tabs.length - 1;
      if(next === null) return;
      e.preventDefault();
      select(next, true);
    });
  });
  root.classList.add('op-ready');
  select(0, false);
})();
